import { SearchBar } from "../../components/search/SearchBar";
import { useData } from "../../context/data-context";
import { ProductCard } from "../../components/product/ProductCard";
import { FilterBar } from "../../components/filters/FilterBar";
import "./products.css";

export const Products = () => {
  const { data } = useData();

  return (
    <div className="products-container">
      <div className="nav">
        <div className="width"></div>
        <SearchBar className="prod-search" />
        <div className="logo-con">
          <img src="../../assets/logo.png" alt="logo" className="logo" />
        </div>
      </div>
      <div className="prod-sec">
        <FilterBar />
        {data.length === 0 ? (
          <h2 className="no-prods">No product to Display</h2>
        ) : (
          <div className="prod-display">
            {data?.map((prod) => (
              <ProductCard key={prod.id} prod={prod} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
